import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueClipboard from "vue-clipboard2";
import store from "@/store";
Vue.use(ElementUI);
VueClipboard.config.autoSetContainer = true;
Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.prototype.$store = store;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
